import { render, staticRenderFns } from "./new-endorsement-ticket.vue?vue&type=template&id=32418104&scoped=true&"
import script from "./new-endorsement-ticket.vue?vue&type=script&lang=js&"
export * from "./new-endorsement-ticket.vue?vue&type=script&lang=js&"
import style0 from "./new-endorsement-ticket.vue?vue&type=style&index=0&id=32418104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32418104",
  null
  
)

export default component.exports